import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from "react-toastify";
import defaultValues from '../../constant/defaultValues';
import { hideLoading, showLoading } from '../../actions/loaderAction';
import { getInquiryRawData, deleteRawData } from "../../actions/inquiryAction";
import AcSimpleTable from "../../components/AcSimpleTable";
import SubHeader from "../../components/SubHeader";
import { capitalize, debounce, find, isEmpty, size } from "lodash";
import ButtonAdd from "../../components/ButtonAdd";
import MediumPopup from "../../components/MediumPopup";
import Choosefile from "../../components/Choosefile";
import { useAuth } from '../../AuthProvider';
import InputField from '@/components/InputField';
import { setAuthHeaders, showErrorMessage, showSuccessMessage } from '../../utils/common';
import errorMessages from "../../constant/errorMessages";
import axiosInstance from '../../axiosHttp';
import API_URL from "../../constant/api.config";
import SmallPopup from '@/components/SmallPopup';
import ToolipsCustom from '@/components/ToolipsCustom';



function InquiryRawData(props) {
    const { admin } = defaultValues;
     const { user, isEndUser, isSuperAdmin, isViewer, isPreKYCUser, isDemoUser, isOpUser, isInqUser, isAdmin} = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [dataList, setDataList] = useState([]);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [columnName, setColumnName] = useState("ID");
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [currentPage, setCurrentPage] = useState(1);
    const [nodata, setNoData] = useState(false);

    const [verrors, setVErrors] = useState({});
    const [csvFile, setCsvFile] = useState(null);
    const [mediummodalShow, setMediumModalShow] = useState(false);

    const maxSize = 2 * 1024 * 1024; // 2mb

    const styleError = {
        display: "block",
    };

        const [smallmodalShow, setSmallModalShow] = useState(false);
        const [deleteRawId, setDeleteRawId] = useState();
    
    const columns = [
        { name: "Company Name", selector: r => r.company_name, sortable: false, wrap: true,
        width: "25%", },
        // { name: "Contact Person", selector: r => r.contact_person, sortable: true },
        // { name: "Designation", selector: r => r.designation, sortable: true },
        { name: "Email", selector: r => r.email, sortable: false, wrap: true,
        width: "25%",style: { wordBreak: "break-all" }, },
        // { name: "Phone", selector: r => r.phone_no, sortable: true },
        { name: "Country", selector: r => r.country?.name, sortable: false, wrap: true,
        width: "12%",},
        { name: "Category", selector: r => r.category?.category_name, sortable: false,wrap: true,
        width: "15%", },
        // { name: "Product", selector: r => r.product, sortable: true },
        { name: "Trade Mode", selector: r => r.trade_mode, sortable: false,wrap: true,
        width: "11%",},
        // { name: "Trade Mode Type", selector: r => r.trade_mode_type, sortable: true },
        ...(isSuperAdmin
        ? [
              {
                  name: 'Action',
                  selector: row => (
                      <ToolipsCustom
                          subtitle="Delete"
                          className="fa-solid fa-trash-can icon-trash border-0"
                          classNameChild="data-table-tooltiop"
                          onClick={() => handleRemoveData(row.id)}
                      />
                  ),
                  columnName: '',
                  sortable: false,
                  width: "10%"
              }
          ]
        : [])
    ];

    const filterRawData = async (
        ofst = 0, lmt = admin.LIMIT, page = 1,
        colName = columnName, sortDir = sortDirection, search = searchTxt
    ) => {
        props.showLoading();
        setNoData(false);
        try {
            const response = await props.getRawData({
                offset: ofst, limit: lmt,
                columnName: colName, sortDirection: sortDir,
                table_search: search,
            });
            if (response?.status === true) {
                if (size(response.data) === 0) setNoData(true);
                setDataList(response.data);
                setTotalRows(response.metadata.total);
            }
        } catch (err) {
            console.log("Error ==== ", err);
        } finally {
            props.hideLoading();
        }
    };

    // initial load
    useEffect(() => {
        filterRawData(admin.OFFSET, admin.LIMIT, 1, "ID", admin.SORT_DIRECTION, "");
    }, []);

    // debounced search
    const debouncedSearch = useRef(
        debounce((val) => {
            setOffset(0);
            setCurrentPage(1);
            filterRawData(0, limit, 1, columnName, sortDirection, val);
        }, 500)
    ).current;

    const handleSearch = (e) => {
        setSearchTxt(e.target.value);
        debouncedSearch(e.target.value);
    };

    // called by AcSimpleTable on page / page-size change
    const getData = (ofst, lmt, page, colName, sortDir) => {
        filterRawData(ofst, lmt, page, colName ?? columnName, sortDir ?? sortDirection, searchTxt);
    };

    const handleSort = (column, direction) => {
        const dir = direction.toUpperCase();
        setColumnName(column.name);
        setSortDirection(dir);
        setOffset(0);
        setCurrentPage(1);
        filterRawData(0, limit, 1, column.name, dir, searchTxt);
    };

  

    const openImportModal = () => {
        setVErrors({});
        setCsvFile(null);
        setMediumModalShow(true);
    };

    const allowedExtensions = ["csv", "xlsx", "xls"];

    const allowedMimeTypes = [
    "text/csv",
    "application/csv",
    "application/vnd.ms-excel", // .xls (and sometimes .csv on Windows)
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ];

    const isValidSpreadsheet = (file) => {
        if (!file) return false;
        const ext = file.name.split(".").pop().toLowerCase();
        return allowedExtensions.includes(ext) && (allowedMimeTypes.includes(file.type) || file.type === "");
        };

        const handleImportFileChange = (e) => {
        let er = { ...verrors };
        const file = e.target.files?.[0];

        console.log('handleImportFileChange --> file --> ', file);
        console.log('handleImportFileChange --> file.type --> ', file?.type);

        if (!file) {
            er.csvFile = errorMessages.FIELD_REQUIRED;
        } else if (!isValidSpreadsheet(file)) {
            er.csvFile = "The file must be of type csv, xlsx or xls.";
        } else if (file.size > maxSize) {
            er.csvFile = "The file must be less than or equal to 2 MB";
        } else {
            er.csvFile = "";
        }

        setVErrors(er);
        setCsvFile(file ?? null);
    };

    const handleImportFileSubmit = (e) => {
        let resheaders = setAuthHeaders();
        let headers = resheaders.headers;
        headers['content-type'] = 'multipart/form-data';
         if (fileValidation()) {
            let fd = new FormData();
            fd.append("csvFile", csvFile);
            console.log("handleImportFileSubmit --> csvFile --> ", csvFile);
            axiosInstance
                .post(API_URL + "/import-member-raw-data", fd, { headers })
                .then((response) => {
                    console.log("response",response);
                    if (response.data.status == true) {
                        showSuccessMessage(response.data.message);
                        setMediumModalShow(false);
                        filterRawData(admin.OFFSET, admin.LIMIT, 1, "ID", admin.SORT_DIRECTION, "");
                    } else if (response.data.status == false) {
                            
                            if (!isEmpty(response.data.error.csvFile)) {
                            let newErrors = {};
                            newErrors.csvFile = response.data.error.csvFile[0];
                            setVErrors(newErrors);
                        } 
                    }
                }).catch((error) => {
                    const data = error.response?.data;

                    if (error.response?.status === 422 && data) {
                        const csvError = data.error?.csvFile?.[0];

                        if (csvError) {
                            setVErrors({ csvFile: csvError });
                        } else if (data.message) {
                            showErrorMessage(data.message); // or your toast function
                        }
                    } else {
                        console.log("Something went wrong!.", error);
                    }
                   
                });
         }
    };

    const fileValidation = () => {
        let er = { ...verrors };
        if (csvFile == "" || csvFile == null) {
            er.csvFile = errorMessages.FIELD_REQUIRED;
        } else if (!isValidSpreadsheet(csvFile)) {
            er.csvFile = "The file must be of type csv, xlsx or xls.";
        } else if (csvFile.size > maxSize) {
            er.csvFile = "The file must be less than or equal to 2 MB";
        } else {
            er.csvFile = "";
        }

        setVErrors(er);
        return !isEmpty(er.csvFile) ? false : true;
    };


    const expandedRowComponent = ({ data }) => {
        return (

            <div style={{ padding: '20px', borderTop: '1px solid #ddd' }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: '22px',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px'
                }}>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Contact Person:</strong> {(data.contact_person ? data.contact_person : '') + ` ` + (data.first_name ? data.first_name : '') + ` ` + (data.last_name ? data.last_name : '')}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Designation:</strong> {data.designation || '-'}
                        </div>
                        
                    </div>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Phone No:</strong> {data.phone_no || '-'}
                        </div>
                         <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Trade Mode Type: </strong> {data.trade_mode_type ? data.trade_mode_type : '-'}
                        </div>
                       
                    </div>
                    <div>
                       
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Product: </strong> {data.product ? data.product : '-'}
                        </div>
                        
                       

                    </div>
                </div>
            </div>
        );
    };

    const handleRemoveData = (id) => {
        setSmallModalShow(true);
        setDeleteRawId(id);
    }

    const handleConfirmDeleteClick = async () => {
            await props
                .deleteMemberRawData(deleteRawId)
                .then((response) => {
                    setSmallModalShow(false);
                    if (response.status === true) {
                        showSuccessMessage("Deleted successfully...");
                        setTimeout(async () => {
                            filterRawData(admin.OFFSET, admin.LIMIT, 1, "ID", admin.SORT_DIRECTION, "");
                            props.hideLoading();
    
                        }, 0);
                    }
    
                })
                .catch((err) => {
                    console.log("Error == ", err);
                    showErrorMessage("Something went wrong");
                });
        };

   

    return (
        <div className="data-table-main logistic-table">
            <div className="AcSimpleTable">
                <SubHeader layer1="Supplier Raw Data" layer2="" layer3="List" pageName="Supplier Raw Data"
                    clickable={{ layer1: "", layer2: "", layer3: "" }} />
                
                <div className="card1">
                    <div className="table-header-name">
                        <h5 className='table-text py-3'>List</h5>
                        <div className='d-flex justify-content-between align-items-center py-3'>
                            <label className='mx-3'>Search</label>
                            <InputField
                                type="text"
                                id="filter-text-box"
                                placeholder="Search..."
                                className='w-25 '
                                // onKeyUp={handleSearch}
                                onChange={handleSearch}
                                autoComplete="off"
                                value={searchTxt}
                            ></InputField>

                            {isSuperAdmin && (
                                <ButtonAdd className='export-btn ms-2' type="button" onClick={openImportModal}>
                                    <i className="fa-solid fa-upload"></i> Import csv
                                </ButtonAdd>
                            )}
                    </div>

                        
                    </div>

                    <div className="table-wrapper">
                        <div className="table-container">
                            <AcSimpleTable
                                key={tableKey}
                                data={dataList}
                                title=""
                                pagination
                                paginationPageSize={limit}
                                columns={columns}
                                progressPending={loading}
                                paginationTotalRows={totalRows}
                                fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                getData={getData}
                                offset={offset}
                                limit={limit}
                                columnName={columnName}
                                sortDirection={sortDirection}
                                setLimit={setLimit}
                                setOffset={setOffset}
                                setLoading={setLoading}
                                paginationPerPage={limit}
                                paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                striped
                                searchTxt={searchTxt}
                                sortServer
                                onSort={handleSort}
                                defaultSortAsc={false}
                                setCurrentPage={setCurrentPage}
                                noData={nodata}
                                expandableRows
                                expandableRowsComponent={expandedRowComponent}
                                expandOnRowClicked={false}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <MediumPopup
                title={"Import File"}
                mediummodalShow={mediummodalShow}
                setMediumModalShow={setMediumModalShow}
                onSubmit={handleImportFileSubmit}
                okButtonLabel={"Import"}
                closeButtonLabel="Cancel"
            >
                <Choosefile
                    className={`form-control`}
                    type="file"
                    accept="text/csv"
                    onChange={handleImportFileChange}
                />
                <p className="upload-info">Allowed CSV, Max size of 2 MB.</p>
                {verrors.csvFile && (
                    <span className="company-required" style={styleError}>
                        {verrors.csvFile}
                    </span>
                )}
            </MediumPopup>

              <SmallPopup
                title="Delete Member"
                smallmodalShow={smallmodalShow}
                setSmallModalShow={setSmallModalShow}
                onSubmit={handleConfirmDeleteClick}
                closeButtonLabel="Cancel"
                okButtonLabel="Delete"
            >
                <div className='row my-3'>
                    <div className="col-md-12 p-0">Are you sure you want to delete?</div>
                </div>
            </SmallPopup>

            
            {/* <ToastContainer /> */}
        </div>
    );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    getRawData: (filterData) => dispatch(getInquiryRawData(filterData)),
    deleteMemberRawData: (id) => dispatch(deleteRawData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InquiryRawData);